import { render, staticRenderFns } from "./ReadingMessage.vue?vue&type=template&id=2047c5d8&"
import script from "./ReadingMessage.vue?vue&type=script&lang=js&"
export * from "./ReadingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports